module.exports = __webpack_public_path__ + "static/img/user.1778636131768.png";